export default __webpack_public_path__ + "static/media/SWT1070.34I-42022_-25179_0.fe94da09.jpg";